<template>
  <div>
    <PageHeader :schema="$schemas.typeInstallment" />
    <PageContent>
      <DynamicFormPage
        :schema="$schemas.typeInstallment"
        :service="$api.typeInstallments"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateTypeInstallment',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
